/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Task_Reminders_RemoveInputs */

const en_task_reminders_remove = /** @type {(inputs: Task_Reminders_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remove reminder`)
};

const pt_br2_task_reminders_remove = /** @type {(inputs: Task_Reminders_RemoveInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Remover lembrete`)
};

/**
* | output |
* | --- |
* | "Remove reminder" |
*
* @param {Task_Reminders_RemoveInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const task_reminders_remove = /** @type {((inputs?: Task_Reminders_RemoveInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Task_Reminders_RemoveInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_task_reminders_remove(inputs)
	return pt_br2_task_reminders_remove(inputs)
});